export default "__VITE_ASSET__B5Iu06sh__"